




import { Component, Prop, Vue } from "vue-property-decorator";
import { GrabPostProperties } from "@/services/posts/postTypes/grab";

@Component
export default class IFrame extends Vue {
    @Prop() private properties!: GrabPostProperties;
    @Prop() private id!: string;

    loaded = false;
    iFrameStyle = {};

    // lifecycle hooks
    async created() {
        this.loaded = false;
        this.iFrameStyle = {
            "margin-left": "-" + this.properties.x + "px",
            "margin-top": "-" + this.properties.y + "px",
            transform: "scale(" + this.properties.zoom / 100 + ")",
            "transform-origin": `${this.properties.x}px ${this.properties.y}px`
        };
        this.loaded = true;
    }
}
